import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

import {
    userSearchResultCrmIdsDataSelector,
    userSearchResultCrmIdsResultSelector,
} from '../../slices/user-search-result-crm-ids.slice';

type Props = {
    userId: number,
};

export const HubspotIdCell = ({userId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultCrmIdsDataSelector);
    const result = useSelector(userSearchResultCrmIdsResultSelector);

    const hubspotId = useMemo(
        () => result?.data[userId]?.hubSpotId,
        [result, userId],
    );

    if (isLoading || loadingError || !hubspotId) {
        return null;
    }

    return (
        <EllipsisTextHint title={hubspotId.toString()}>{hubspotId}</EllipsisTextHint>
    );
};
